<script setup lang="ts">
const isOpen = ref(false);

// Function to close sidebar
const closeSidebar = () => {
  isOpen.value = false;
};

// Provide closeSidebar function to Sidebar component
provide("closeMobileSidebar", closeSidebar);

// The sheet opens from the reading-start edge, next to the menu button
const isRtl = useIsRtl();
</script>

<template>
  <Sheet v-model:open="isOpen">
    <SheetTrigger as-child>
      <Button
        variant="outline"
        class="md:hidden pe-4 hover:opacity-75 transition"
        :aria-label="$t('landing.seo.nav.openMenu')"
      >
        <Icon name="lucide:menu" class="h-5 w-5" aria-hidden="true" />
      </Button>
    </SheetTrigger>
    <SheetContent :side="isRtl ? 'right' : 'left'" class="w-72 bg-background p-0" :aria-describedby="undefined">
      <SheetTitle class="sr-only">{{ $t("common.mainNavigation") }}</SheetTitle>
      <Sidebar @linkClick="closeSidebar" />
    </SheetContent>
  </Sheet>
</template>
